import { type ReactNode } from 'react'
import { AppContext } from './AppContext'
import type { IContainer } from 'bottlejs'
import type { DiId } from '@/common/di/di-ids'

type ContainerProviderProps = {
  children: ReactNode
  container: IContainer<DiId>
}

export function ContainerProvider({ children, container }: ContainerProviderProps) {
  return <AppContext.Provider value={container}>{children}</AppContext.Provider>
}
